import AbstractCreateAction from '../abstract-create-action';

/**
 * Create action for managing skischool offers.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class CreateAction extends AbstractCreateAction {
    constructor(container: HTMLElement) {
        super(container);
        CreateAction.emitter.emit('ready', this);
    }
}
